<template>
  <div class="download">
    <div class="abstract">
      <div class="abstract-text">
        <div class="title-container">
          <div class="nMobile-icon"></div>
          <div>
            <div class="text-title">{{$t('nMobileProDownload.nMobile')}}</div>
            <div class="text-title-2">{{$t('nMobileProDownload.extraSecureChat')}}</div>
            <h4>{{$t('nMobileProDownload.powered')}}</h4>
          </div>
        </div>

        <p class="text-detail">{{$t('nMobileProDownload.description')}}</p>
        <div class="download-buttons">
          <a target="_blank" href="https://apps.apple.com/us/app/nmobile-pro/id1524552323">
            <img class="img-button" src="../../static/img/nMobile-download/app-store.png" alt/>
          </a>
          <div class="item-2">
            <a target="_blank" href="https://play.google.com/store/apps/details?id=org.nkn.nmobilePro">
              <img class="img-button" src="../../static/img/nMobile-download/google-play.png" alt/>
            </a>
          </div>
        </div>
        <div class="download-buttons">
         <!-- <div class="item-1">
            <a target="_blank" href="https://github.com/nknorg/nMobile">
              <img class="img-button" src="../../static/img/nMobile-download/github-button.png" alt/>
            </a>
          </div>-->
          <div class="item-1">
          </div>
          <div class="item-2">
            <a @click="downloadApk">
              <img class="img-button" src="../../static/img/nMobile-download/android.png" alt/>
            </a>
            <div class="qrcode-button">
              <span class="nMobile">&#xe6a5;</span>
              <div class="qrcode">
                <qrcode-vue :value="value" :size="size"></qrcode-vue>
                <div style="text-align: center">Android APK {{$t('nMobileProDownload.ScanToDownload')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="abstract-img">
        <img src="/static/img/nMobile-download/banner-2.png" alt/>
      </div>
    </div>


    <div class="modal-wxtips" v-if="showModal" @click="showModal = false">
      <span class="wxtip-icon"></span>
      <p class="wxtip-txt" v-html="$t('nMobileProDownload.wxtips')"></p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import QrcodeVue from 'qrcode.vue';

  export default {
    data() {
      return {
        value: location.href,
        nMobileBeta: 'https://nmobile.nkn.org/downloads/nMobile-beta.apk',
        size: 150,
        showModal: false
      };
    },
    computed: {
      ...mapState({
        lang: state => state.lang.lang
      })
    },
    components: {QrcodeVue},
    methods: {
      downloadApk() {
        const ua = navigator.userAgent;
        const isWeixin = !!/MicroMessenger/i.test(ua);
        if (isWeixin) {
          this.showModal = true
        } else {
          window.open(this.$t('home.communityDApp.nMobilePro.url'))
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .download {
    color: #000000;

    .nkn-container {
      @media screen and (max-width: 768px) {
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
        align-items: center;
      }
      max-width: 1200px;
      justify-content: center;
      align-items: center;
      width: 100%;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      z-index: 100;
      flex-wrap: wrap;
      align-items: stretch;

      .column {
        width: 400px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 40px;

        .image {
          display: flex;
          align-items: center;
          height: 6rem;
        }

        img {
          display: block;
          width: auto;
          height: 6rem;
        }
      }
    }

    .secure-container {
      display: flex;
      align-items: center;
      @media (max-width: 992px) {
        flex-direction: column;
      }

      .image {
        display: flex;
        align-items: center;
        padding-left: 20px;
        padding-right: 20px;
      }

      .detail {
        margin-left: 20px;
        margin-right: 20px;
        display: block;
        font-size: 1.2rem;
        font-weight: 400;
        text-align: justify;
        line-height: 1.5;
        color: #333;
      }

      img {
        display: block;
        max-width: 100%;
        width: auto;
        height: auto;
      }

      > * {
        flex: 1;
        display: flex;
      }
    }

    .title {
      display: block;
      font-size: 0.9rem;
      color: #1791f2;
      font-weight: 400;
      line-height: 1rem;
      margin-top: 2rem;
    }

    .detail {
      display: block;
      font-size: 0.7rem;
      font-weight: 400;
      text-align: justify;
      line-height: 1rem;
      margin-top: 1rem;
      color: #333;
    }

    .abstract {
      display: flex;
      max-width: 1200px;
      margin: 0 auto;
      @media (max-width: 992px) {
        flex-direction: column;
        padding: 20px 10px 0 10px;
      }
      justify-content: space-between;
      align-items: center;

      .abstract-text {
        width: 60%;
        @media (max-width: 992px) {
          width: 100%;
        }

        h4 {
          color: #0096ff;
          font-weight: 500;
          margin: 0;
          line-height: 1.5;
        }

        .title {
          font-size: 0.9rem;
          color: #1791f2;
          font-weight: 400;
          line-height: 1rem;
          min-width: 100px;
        }

        .title-container {
          display: flex;
          margin-bottom: 20px;
          justify-content: center;
          align-items: center;

          .nMobile-icon {
            height: 100px;
            width: 100px;
            background-size: cover;
            background-image: url(/static/img/nMobile-download/nMobile-pro-icon.png);
            border-radius: 20px;
            @media (max-width: 992px) {
              height: 80px;
              width: 80px;
            }

            ~ * {
              margin-left: 10px;
            }
          }

        }

        .text-detail {
          padding: 0 20px;
          color: rgb(93, 103, 119);
        }

        .text-title {
          font-size: 1.5rem;
          color: #253a7e;
          font-weight: bold;
          line-height: 1.2;
        }

        .text-title-2 {
          font-size: 1.1rem;
          line-height: 1.2;
        }

        .download-buttons {
          margin-top: 20px;
          display: flex;
          justify-content: space-around;
          align-items: center;

          .item-2 {
            width: 210px;
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            @media (max-width: 992px) {
              width: 170px;
            }
          }

          .item-1 {
            width: 150px;
            @media (max-width: 992px) {
              width: 120px;
            }
          }

          .img-button {
            width: 150px;
            @media (max-width: 992px) {
              width: 120px;
            }
          }

          .download-button {
            width: 210px;
            display: inline-block;
            text-decoration: none;
            border-radius: 3px;
            padding: 5px 20px;
            transition: all 0.5s;
            border: 1px solid gray;
            @media (max-width: 992px) {
              width: 150px;
              padding: 5px 10px;
            }

            &:hover {
              transition: all 0.5s;
              border: 1px solid black;
            }

            .button-row {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: row;

              .button-icon {
                font-size: 36px;
                @media (max-width: 992px) {
                  font-size: 24px;
                }
              }

              .button-column {
                margin-left: 10px;
                display: flex;
                flex-direction: column;

                .top-text {
                  font-size: 12px;
                  color: gray;
                }

                .bottom-text {
                  font-size: 20px;
                  font-weight: bold;
                  @media (max-width: 992px) {
                    font-size: 16px;
                  }
                }
              }
            }
          }

          .qrcode-button {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            padding: 5px 20px;
            transition: all 0.5s;
            display: flex;
            background-color: #000;
            justify-content: center;
            align-items: center;
            position: relative;
            color: #fff;

            &:hover {
              cursor: pointer;
              transition: all 0.5s;
              border: 1px solid black;

              .qrcode {
                display: block;
                color: #000;
              }
            }

            @media (max-width: 992px) {
              width: 38px;
              height: 38px;
              /*display: none;*/
            }

            .qrcode {
              background-color: #ffffff;
              color: #000;
              z-index: 999;
              padding: 20px 20px 10px 20px;
              box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 20px;
              border-radius: 3px;
              position: absolute;
              display: none;
              top: 73px;
            }

            .nMobile {
              font-size: 36px;
              @media (max-width: 992px) {
                font-size: 30px;
              }
            }
          }
        }

      }

      .abstract-img {
        display: flex;
        justify-content: center;
        flex: 1;
        margin: 40px 20px;
        height: 600px;
        img {
          display: block;
          height: 100%;
          /*height: 200%;*/
        }
      }
    }

    .user-benefits-container {
      background-color: #f9faff;
      padding: 40px 0;

      .user-benefits {
        max-width: 1200px;
        margin: 0 auto;

        .title {
          font-size: 1.5rem;
          color: #253a7e;
          font-weight: 400;
          text-align: center;
          padding: 0 0 40px 0;
        }

        .content {
          // display: flex;
          // justify-content: space-between;
          img {
            width: 110px;
          }

          @media (max-width: 992px) {
            flex-direction: column;
            img {
              width: 100px;
            }
          }

          .item {
            // padding: 12px 15px;
            // display: flex;
            // flex-direction: column;
            // flex: 1;
            .item-container {
              width: 260px;
              margin: 0 auto;

              .img-container {
                text-align: center;
                height: 123.75px;
              }

              @media (max-width: 992px) {
                margin-bottom: 40px;
                // &:last-child {
                //   margin: 0;
                // }
              }
              // justify-content: center;
              align-items: center;

              .imgs {
                display: flex;
                justify-content: center;
                align-items: center;
              }

              .item-title {
                display: flex;
                justify-content: center;
                font-size: 0.9rem;
                color: #1791f2;
                font-weight: 400;
                line-height: 1rem;
                margin-top: 2rem;
              }

              .item-content {
                display: block;
                font-size: 0.7rem;
                font-weight: 400;
                text-align: justify;
                line-height: 1rem;
                margin-top: 1rem;
                color: #333;

                a {
                  color: #1791f2;
                }
              }
            }
          }
        }
      }
    }

    .learn-more {
      max-width: 1200px;
      margin: 0 auto;
      padding: 40px 0;

      .learn-more-title {
        font-size: 1.2rem;
        color: #1791f2;
        font-weight: 400;
        line-height: 2;
      }

      .learn-more-content {
        display: flex;

        .learn-more-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 40px;
        }

        a {
          text-align: center;
        }

        @media (max-width: 992px) {
          flex-direction: column;
          &:last-child {
            margin-bottom: 0;
          }
        }
        justify-content: space-around;
        align-items: center;

        img {
          width: 400px;
          @media (max-width: 992px) {
            width: 300px;
          }
        }
      }
    }

    .modal-wxtips {
      background: rgba(0, 0, 0, 0.8);
      text-align: center;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 99999;

      .wxtip-icon {
        width: 52px;
        height: 67px;
        background: url(/static/img/nMobile-download/weixin-tip.png) no-repeat;
        display: block;
        position: absolute;
        right: 20px;
        top: 20px;
      }

      .wxtip-txt {
        padding: 0 40px;
        margin-top: 107px;
        color: #fff;
        font-size: 16px;
        line-height: 1.5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/NMobileProDownload.vue